import React, { useContext } from 'react';
import cn from 'classnames';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { AuthContext } from 'context/AuthContext';
import { ReactComponent as EyeIcon } from 'assets/img/icons/eye.svg';
import { ReactComponent as EditIcon } from 'assets/img/icons/edit.svg';

export default function ExternalUserBanner({
  className = '',
  hasMaxWidth = false
}) {
  const { isExternalUser, externalUserAccess, storeProperties } = useContext(
    AuthContext
  );

  const storeName = _get(storeProperties, 'store_name', '');
  const ssSellerId = _get(storeProperties, 'ss_seller_id', '');
  const storeUniqueName = _get(storeProperties, 'store_unique_name', '');
  const isSSR = _get(storeProperties, 'is_ssr_retailer', false);

  const isReadMode = externalUserAccess === 'READ';
  const mode = isReadMode ? 'Read' : 'Edit';
  const icon = isReadMode ? (
    <EyeIcon width="14" height="14" className={styles.readIcon} />
  ) : (
    <EditIcon width="12" height="12" className={styles.writeIcon} />
  );

  if (!isExternalUser || !externalUserAccess) return null;

  return (
    <div
      className={cn(styles.container, className)}
      data-mode={isReadMode ? 'READ' : 'WRITE'}
      data-app={isSSR ? 'SSR' : 'RR'}
    >
      <UiKit.MaxWidthContainer isExtended={!hasMaxWidth}>
        <UiKit.Grid
          templateColumns="216px 1fr 216px"
          gap="24"
          className={styles.content}
        >
          <UiKit.Grid templateColumns="auto 1fr" gap="8">
            <UiKit.Badge variant={isReadMode ? 'light' : 'dark'}>
              {icon}
              <strong>{mode}</strong>
            </UiKit.Badge>
            <If test={isSSR}>
              <UiKit.Badge variant="dark">
                <strong>SSR {ssSellerId ? `- ${ssSellerId}` : ''}</strong>
              </UiKit.Badge>
            </If>
          </UiKit.Grid>
          <p className={styles.helptext}>
            Visiting &quot;{storeName}&quot; ({storeUniqueName}) with{' '}
            <strong>{mode} access</strong>.{' '}
            <If test={!isReadMode}>
              <span>Changes will reflect on the </span>
              <strong>Merchant portal of the Client</strong>.
            </If>
          </p>
        </UiKit.Grid>
      </UiKit.MaxWidthContainer>
    </div>
  );
}
